import { imageAsset, link } from '@/data/sanity/fragments'
import cmsSettings from '../cmsSettings'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  sectionBackground,
  title,
  subtitle,
  isNew,
  description,
  disclaimers[]{ text, showAsterisk },
  mediaStyle,
  images[]{${imageAsset.fields}},
  ${link.fragment('breadcrumbLink1')},
  ${link.fragment('breadcrumbLink2')},
  ${link.fragment('cta')}
`

export const fragment = (name = 'textAndImageHeroWithBreadcrumbs') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
